<template>
	<div>
		<b-form-textarea
			:value="value"
			v-model="proxyValue"
			:placeholder="placeholder"
			:readonly="!active"
			:state="state"
			:rows="minRows"
			:max-rows="maxRows"
			:disabled="disabled"
			@keypress.enter="emitEnterEvent"
			:class="{ unresizable: !isResizable, 'overflow-hidden': hideOverflow }"
			:formatter="needsFormatter ? defaultFormatter : null"
			@input="handleInput"
			ref="textareaElement"
		></b-form-textarea>
		<b-form-invalid-feedback :id="`${name}-feedback`" :state="state">
			{{ errors[name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: String
		},
		placeholder: {
			type: String
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		name: {
			type: String
		},
		state: {
			type: Boolean
		},
		errors: {
			type: Object
		},
		minRows: {
			type: Number
		},
		maxRows: {
			type: Number
		},
		isResizable: {
			type: Boolean,
			default: true
		},
		hideOverflow: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: [Boolean, Function],
			required: false
		},
		toUpperCase: {
			type: Boolean,
			default: false
		},
		formatter: {
			type: Function
		},
		textCasing: {
			type: String,
			validator(value) {
				return [this.$LetterCaseEnum.Upper, this.$LetterCaseEnum.Lower, this.$LetterCaseEnum.All].includes(value);
			}
		},
		allowedChar: {
			type: Object
		}
	},
	data() {
		return {
			active: true,
			isUpdating: false
		};
	},
	beforeMount() {
		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;
	},
	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", this.name);
			}
		},
		needsFormatter() {
			const allowedChar = Array.isArray(this.allowedChar) ? this.allowedChar : [];
			const usedTextCasing =
				this.textCasing == this.$LetterCaseEnum.Upper || this.textCasing == this.$LetterCaseEnum.Lower;
			const usedFormatter = typeof this.formatter === "function";
			const allowedCharUsed = allowedChar.length > 0;

			return allowedCharUsed || usedTextCasing || usedFormatter;
		}
	},
	methods: {
		getValue: function () {
			this.$emit("value", this.value);
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		},
		emitEnterEvent: function () {
			this.$emit("enterPress");
		},
		getTextareaElement() {
			// Se é um b-form-textarea, o elemento real está em $el
			if (this.$refs.textareaElement && this.$refs.textareaElement.$el) {
				return this.$refs.textareaElement.$el;
			}
			// Fallback para textarea direto
			return this.$refs.textareaElement;
		},
		handleInput(event) {
			if (this.toUpperCase && !this.needsFormatter && !this.isUpdating) {
				const textarea = this.getTextareaElement();
				const { cursorPosition, currentValue } = this.$functions.getCursorPositionAndValue(textarea, event, this.value);

				this.$functions.applyUpperCaseWithCursorPreservation(
					currentValue,
					cursorPosition,
					textarea,
					(upperValue) => {
						this.isUpdating = true;
						this.proxyValue = upperValue;
						// Callback para resetar isUpdating após restaurar cursor
						this.$functions.restoreCursorPosition(textarea, cursorPosition, () => {
							this.isUpdating = false;
						});
					}
				);
			}
		},
		defaultFormatter(value) {
			return this.$functions.defaultFormatter(value, {
				allowedChar: this.allowedChar,
				textCasing: this.textCasing,
				formatter: this.formatter,
				toUpperCase: this.toUpperCase
			});
		}
	}
};
</script>
<style scoped>
.unresizable {
	resize: unset;
}
.overflow-hidden {
	overflow: hidden;
}
</style>
